import { takeLatest } from 'redux-saga/effects';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED } from '../actionTypes/CartActionTypes';

function* rewardsPointsEarnedSaga(action) {
    try {
        const {
            payload: { rewardsId = '', rewardsTier = '' },
        } = action;
        if (rewardsId) {
            TokenProvider.set('DP_REWARDS_ID', rewardsId);
            TokenProvider.set('DP_REWARDS_TIER', rewardsTier.toLowerCase());
        }
    } catch (ex) {
        console.log(ex);
    }
}

const watchRewardsPointsEarned = function* watchRewardsPointsEarned() {
    yield takeLatest(WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED, rewardsPointsEarnedSaga);
};
watchRewardsPointsEarned.sagaName = 'watchRewardsPointsEarned';

export default watchRewardsPointsEarned;
